<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        Listado de operadores externos
        <!-- <v-icon>fas fa-lock</v-icon> -->
      </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            v-on="on"
            dark
            class="mb-2"
            v-if="isExternalDriverCreate"
          >Nuevo operador</v-btn>
        </template>

        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8 md8>
                  <v-text-field v-model="editedItem.Name" label="Nombre"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.EconomicNumber" label="Unidad"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md8>
                  <v-text-field v-model="editedItem.TransportLine" label="Linea de transportes"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.LicencePlate" label="Placas"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md8>
                  <v-text-field v-model="editedItem.Client" label="Cliente"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.Origin" label="Origen"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md8>
                  <v-text-field v-model="editedItem.DriverExtras" label="ID"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.Caat" label="Caat"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="editedItem.PlaceOfPositioning"
                    label="Lugar de posicionamiento"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">Cancelar</v-btn>
            <v-btn color="sencodary" flat @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :footer-props="{
            itemsPerPageOptions: [50, 100, 200], // -> Add this example
      }"
      class="elevation-1"
    >
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="isExternalDriverCreate">edit</v-icon>
        <v-icon small @click="deleteItem(item)" v-if="isExternalDriverCreate">delete</v-icon>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from "vuex";
  export default {
    data: () => ({
      dialog: false,
      textLoading: "Sincronizando operadores...",

      headers: [
        { text: "Name", value: "Name" },
        { text: "Linea de transportes", value: "TransportLine" },
        { text: "Unidad", value: "LicencePlate" },
        { text: "", value: "action", sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        DriverId: "",
        Nombre: "",
        NumeroEmpleado: 0,
        QrCode: null,
        Status: null
      },
      defaultItem: {
        DriverId: "",
        Nombre: "",
        NumeroEmpleado: 0,
        QrCode: null,
        Status: null
      }
    }),
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Registrar empleado" : "Editar empleado";
      },
      isExternalDriverCreate() {
        return this.$store.getters.userInRol("Registrar Operador Externo");
      }
    },
    watch: {
      dialog(val) {
        val || this.close();
      }
    },
    created() {
      this.enableLoading("Sincronizando información");
      this.$store
        .dispatch("getExternalDrivers")
        .then(res => {
          console.log(res);
          this.desserts = res;
          this.disableLoading();
        })
        .catch(e => {
          console.log(e);
        });
      this.initialize();
    },
    methods: {
      ...mapMutations({
        enableLoading: "enableLoadingMessage",
        disableLoading: "disableLoadingMessage"
      }),
      initialize() {
        this.desserts = [];
      },
      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.desserts.indexOf(item);
        let result = confirm("¿Estás seguro que deseas eliminar este operador?");
        console.log(result);
        console.log(item);
        if (result) {
          item.Status = 99;
          console.log("Este es el ITEM");
          console.log(item);
          this.$store
            .dispatch("postExternalDriver", item)
            .then(res => {
              console.log(res);
            })
            .catch(e => {
              console.log(e);
            });
        }

        this.desserts.splice(index, 1);
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        console.log("Este es el ITEM");
        console.log(this.editedItem);
        this.$store
          .dispatch("postExternalDriver", this.editedItem)
          .then(res => {
            console.log(res);
          })
          .catch(e => {
            console.log(e);
          });
        this.close();
      }
    }
  };
</script>